// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__Zoj_b","label":"Completed_label__6zoCm"};